module.exports = __webpack_public_path__ + "static/media/previousquestionsjee.be0851bf.jpeg";